/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import PodiumListItem from './PodiumListItem';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class SelfRankCard extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.token = 0;
    this.refresh();
  }

  // After a 403 the page refetches the board list and swaps boards on the same mount;
  // the rank follows the params the list was last loaded for.
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (app.leaderboard.activityType && this.paramsKey() !== this.requestedFor) {
      this.refresh();
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.removed = true;
  }
  view() {
    if (this.rank === 0) {
      return null;
    }
    if (!this.rank) {
      return m(LoadingIndicator, null);
    }
    return m("div", {
      className: "SelfRankCard"
    }, m(PodiumListItem, {
      user: app.session.user,
      value: this.score,
      position: this.rank,
      positionClass: "first"
    }));
  }
  paramsKey() {
    return JSON.stringify(app.leaderboard.requestParams());
  }
  refresh() {
    const token = ++this.token;
    const isCurrent = () => !this.removed && token === this.token;
    this.rank = undefined;
    this.score = undefined;
    // Claimed up front so redraws while `ready` is pending cannot re-enter refresh().
    this.requestedFor = this.paramsKey();

    // Waits for the board to resolve: the bare route carries no activity type of its own.
    app.leaderboard.ready.then(activityType => {
      if (!isCurrent()) {
        return;
      }

      // Re-read after `ready`, where the page's own continuation has set the params, and
      // before the null check: a stale key on a board-less outcome would make every
      // redraw re-enter refresh(), whose own redraw then loops.
      this.requestedFor = this.paramsKey();
      if (!activityType) {
        return Promise.reject();
      }

      // A 403 is the page's to recover from by refetching the board list.
      return app.store.find('gamilytics_leaderboard_ranks', app.session.user.id(), app.leaderboard.requestParams(), {
        errorHandler: error => isCurrent() && error.status !== 403 ? false : undefined
      });
    }).then(rank => {
      if (!isCurrent()) {
        return;
      }

      // Copied out, not read at render time: the session user and this Rank are store
      // singletons that any later payload — a superseded list or rank response, a post
      // author — rewrites with a score for some other board.
      this.rank = rank.rank();
      this.score = rank.activitySummary();
      m.redraw();
    }).catch(() => {
      if (!isCurrent()) {
        return;
      }
      this.rank = 0;
      m.redraw();
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/SelfRankCard', SelfRankCard);